export function trackGTMEvent(eventName) {
  window.dalaLayer?.push({ event: eventName });
}
